import { REQUIRED_FIELD } from "@/lib/constants";
import { Input } from "@chakra-ui/react";
import { InputMask } from "@react-input/mask";

const ZipCodeInput = ({
  register,
  fieldName = "Zip",
  placeholder = "12345",
  size = "md",
  isOptional = false,
  disabled = false,
}: {
  register: Function;
  fieldName?: string;
  placeholder?: string;
  size?: "md" | "lg";
  isOptional?: boolean;
  disabled?: boolean;
}) => {
  return (
    <Input
      type="text"
      placeholder={placeholder}
      size={size}
      as={InputMask}
      isDisabled={disabled}
      mask="_____"
      replacement={{ _: /\d/ }}
      {...register(fieldName, {
        required: isOptional ? undefined : REQUIRED_FIELD,
        pattern: {
          value: /^\d{5}$/,
          message: "Zip code must be exactly 5 digits",
        },
      })}
    />
  );
};

export default ZipCodeInput;
